<template>
  <v-col cols="12" xl="3" lg="3" md="4" sm="5" xs="12" class="nav-date-col">
    <v-menu
      :close-on-content-click="false"
      :nudge-right="0"
      transition="slide-y-transition"
      offset-y
      min-width="290px"
      v-model="dateMenu"
      light
      class="date-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="filteredDate"
          label="Select date"
          append-icon="mdi-menu-down"
          readonly
          filled
          dense
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="date" :max="today"></v-date-picker>
      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dateMenu = false">Cancel</v-btn>
        <v-btn color="primary" text @click="switchDate">Select</v-btn>
      </v-card-actions>
    </v-menu>
  </v-col>
</template>

<style lang="scss">
.nav-date-col {
  height: 1rem;
  transform: translateY(-0.85rem);

  @media screen and (max-width: 600px) {
    //flex: 0 0 100%;
    background: #fff;
    position: absolute;
    bottom: -1rem;
    height: 3.25rem;
    padding: 7px 10px;

    .v-input {
      .v-label {
        display: none;
      }
    }
  }

  .v-input {
    .v-input__slot {
      @media screen and (max-width: 600px) {
        min-height: 38px !important;

        .v-text-field__slot {
          input {
            margin-top: 0;
          }
        }

        .v-input__append-inner {
          margin-top: 5px !important;
        }
      }

      &::before {
        display: none !important;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.v-menu__content {
  background: #fff;
}
</style>

<script>
export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    today: new Date().toISOString().substr(0, 10),
    dateMenu: false,
  }),
  computed: {
    filteredDate: function () {
      return this.date
        ? this.$moment(this.date).format("dddd,  Do MMMM,  YYYY")
        : "";
    },
  },
  mounted() {
    this.formatDates();
  },
  methods: {
    switchDate() {
      this.$router.push({
        name: "Paper",
        params: {
          year: this.$moment(this.date).format("YYYY"),
          month: this.$moment(this.date).format("MM"),
          date: this.$moment(this.date).format("DD"),
        },
      });
      this.dateMenu = false;
    },
    formatDates() {
	
		var publishing_time = "05:30:00";
	
		var user_date = new Date();
	
		var publish_datetime = (user_date.getUTCMonth()+1)+"/"+user_date.getUTCDate()+"/"+user_date.getUTCFullYear()+" "+publishing_time;		
		publish_datetime = new Date(publish_datetime);
		
		var server_datetime = (user_date.getUTCMonth()+1)+"/"+user_date.getUTCDate()+"/"+user_date.getUTCFullYear()+" "+user_date.getUTCHours()+':'+user_date.getUTCMinutes()+':'+user_date.getUTCSeconds();
		
		server_datetime = new Date(server_datetime);		
		server_datetime.setHours(server_datetime.getHours() + 5);
		server_datetime.setMinutes(server_datetime.getMinutes() + 30);
		
		this.today = this.$moment(server_datetime).format("YYYY-MM-DD");
		
		if(Object.keys(this.$route.params).length == 0){
			if(server_datetime > publish_datetime){		
			
				this.date = this.$moment(server_datetime).format("YYYY-MM-DD");				
			} else {
				var yesterday = new Date(server_datetime);
				yesterday.setDate(new Date().getDate() -1);
				this.date = this.$moment(yesterday).format("YYYY-MM-DD");
				this.today = this.$moment(yesterday).format("YYYY-MM-DD");
			}
		} else {
			var selected_date = this.$route.params.year+'-'+this.$route.params.month+'-'+this.$route.params.date;
			selected_date = Date.parse(selected_date);
			this.date = this.$moment(selected_date).format("YYYY-MM-DD");
		}
	
     /* var currentDate = new Date();		
		currentDate.setHours(20);
		currentDate.setMinutes(30);
		currentDate.setSeconds(0);
		
		var yesterday = currentDate.setDate(new Date().getDate() -1);

		var now = new Date();
		console.log(currentDate);
		if(now > currentDate){
			this.date = this.$moment(now).format("YYYY-MM-DD");
			this.today = this.$moment(now).format("YYYY-MM-DD");
		} else {
			this.date = this.$moment(yesterday).format("YYYY-MM-DD");
			this.today = this.$moment(yesterday).format("YYYY-MM-DD");
		}*/

    },
  },
};
</script>